import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useTechnologies } from '@/hooks';
import { Table } from '@tanstack/react-table';
import { OpportunityItemList } from '@/features/opportunities/types';
import { TableFilterDropdown } from './table-filter-dropdown';

export type TechnologyFilterProps = {
  readonly table: Table<OpportunityItemList>;
  readonly value?: string[];
  readonly onChange: (value: string[]) => void;
  readonly popoverFilter?: boolean;
};
export function TechnologyFilter({ table, value = [], onChange, popoverFilter }: TechnologyFilterProps) {
  const { t } = useTranslation(['home']);

  const { filters: technologies } = useTechnologies();

  const handleChange = useCallback(
    (values: string[]) => {
      const cleaned = Array.from(new Set(values.filter(Boolean).map((v) => v.trim().toLowerCase())));
      onChange(cleaned);
    },
    [onChange]
  );

  return (
    <TableFilterDropdown
      column={table.getColumn('technologies')!}
      title={t('Technologies')}
      options={technologies}
      value={value}
      onChange={handleChange}
      popoverFilter={popoverFilter}
    />
  );
}
